import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item3Props {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item3: React.FC<Item3Props> = ({ required = false, propertyGuid, isReview = false }) => {
    const [item3, set_item3] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #3']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #3': [b.values?.['Expand Primary Structure']?.['Item #3']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Item #3';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(item3)}
                />
            ) : (
                <MoneyBox
                    id={'item3'}
                    allowNegative={false}
                    value={item3}
                    onChange={(value) => set_item3(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
